import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Interior from './pages/services/Interior';
import Exterior from './pages/services/Exterior';
import WoodPainting from './pages/services/WoodPainting';
import TextureDesign from './pages/services/TextureDesign';
import Waterproofing from './pages/services/Waterproofing';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsAndConditions from './pages/legal/TermsAndConditions';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen relative">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/interior" element={<Interior />} />
            <Route path="/services/exterior" element={<Exterior />} />
            <Route path="/services/wood" element={<WoodPainting />} />
            <Route path="/services/texture" element={<TextureDesign />} />
            <Route path="/services/waterproofing" element={<Waterproofing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
      </div>
    </Router>
  );
}

export default App;